var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "alpheios-lookup__form",
      attrs: { id: "alpheios-lookup-form", "data-alpheios-ignore": "all" },
    },
    [
      _c("div", { staticClass: "alpheios-lookup__form-row" }, [
        _c("div", { staticClass: "alpheios-lookup__form-element" }, [
          _c("label", { staticClass: "alpheios-setting__label" }, [
            _vm._v("Word lookup"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "alpheios-lookup__search-control" },
            [
              _c("input-autocomplete", {
                attrs: {
                  lang: _vm.lookupLanguage,
                  clearValue: _vm.clearLookupText,
                  id: _vm.lookupInputName,
                },
                on: {
                  keyPressEnter: _vm.lookup,
                  updateLookupText: _vm.updateLookupText,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "alpheios-button-primary",
                  attrs: {
                    id: "alpheios-lookup-form-button",
                    tabindex: "-1",
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.lookup.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "alpheios-lookup__search-control-label" },
                    [_vm._v(_vm._s(_vm.l10n.getMsg("LABEL_LOOKUP_BUTTON")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "alpheios-lookup__search-control-icon alpheios-navbuttons__btn",
                    },
                    [_c("lookup-icon")],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("beta-codes-info", {
        attrs: { availableUseBetaCodes: _vm.availableUseBetaCodes },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showLangSelector,
              expression: "! showLangSelector",
            },
          ],
        },
        [
          _c(
            "span",
            {
              staticClass: "alpheios-lookup__lang-hint",
              attrs: { id: "alpheios-lookup-form-lang-hint" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.l10n.getMsg("HINT_LOOKUP_LANGUAGE", {
                    language: _vm.lookupLangName,
                  })
                )
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "alpheios-lookup__lang-change",
              attrs: { id: "alpheios-lookup-form-lang-change" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleLangSelector.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.l10n.getMsg("LABEL_LOOKUP_CHANGE_LANGUAGE")))]
          ),
        ]
      ),
      _vm._v(" "),
      _c("alph-setting", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLangSelector,
            expression: "showLangSelector",
          },
        ],
        attrs: {
          classes: [
            "alpheios-panel__options-item",
            "alpheios-lookup__form-element",
            "alpheios-lookup__lang-control",
          ],
          data: this.$options.lookupLanguage,
        },
        on: { change: _vm.settingChangeLL },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }